/** Shared TextField / Select styling for tracker builder & publish settings. */
export const trackerFieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    bgcolor: "#fff",
  },
  "& .MuiOutlinedInput-root:not(.MuiInputBase-multiline)": {
    minHeight: 44,
  },
  "& .MuiOutlinedInput-input": {
    fontSize: 14,
  },
  "& .MuiInputLabel-root": {
    fontSize: 14,
  },
  "& .MuiSelect-select": {
    display: "flex",
    alignItems: "center",
  },
};
